export const FETCH_LIST_ALL_PROJECT_TEMPLATE_REQUEST = 'FETCH_LIST_ALL_PROJECT_TEMPLATE_REQUEST'
export const FETCH_LIST_ALL_PROJECT_TEMPLATE_SUCCESS = 'FETCH_LIST_ALL_PROJECT_TEMPLATE_SUCCESS'
export const FETCH_LIST_ALL_PROJECT_TEMPLATE_FALUIRE = 'FETCH_LIST_ALL_PROJECT_TEMPLATE_FALUIRE'
export const FETCH_SEARCH_PTEMPLATE='FETCH_SEARCH_PTEMPLATE'
